/**
 * 公用静态类
 */

class Fn {
  /**
   * 渲染一张图片
   * @param url
   * @returns {Promise}
   */
  static renderImgTag (url) {
    return new Promise((res, rej) => {
      if (url) {
        let img = new Image()
        
        img.onload = () => {
          res(img)
        }
        
        img.onerror = () => {
          rej(new Error(`Could not load image at ${url}`))
        }
        
        img.src = url
      }
    })
  }
  
  static pauseAllVideo () {
    $('.ytb-iframe').map((index, el) => {
      console.log(el)
      el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    })
  }
}

export default Fn
